__turbopack_context__.v({
  "active": "FIqlRW_active",
  "block": "FIqlRW_block",
  "characterLimit": "FIqlRW_characterLimit",
  "characterSupport": "FIqlRW_characterSupport",
  "colors": "FIqlRW_colors",
  "contacts": "FIqlRW_contacts",
  "content": "FIqlRW_content",
  "disabled": "FIqlRW_disabled",
  "disclaimer": "FIqlRW_disclaimer",
  "disclaimerText": "FIqlRW_disclaimerText",
  "engravingHints": "FIqlRW_engravingHints",
  "errorMessage": "FIqlRW_errorMessage",
  "form": "FIqlRW_form",
  "formContainer": "FIqlRW_formContainer",
  "inputRows": "FIqlRW_inputRows",
  "manualSizeSelectContainer": "FIqlRW_manualSizeSelectContainer",
  "manualSizeToggle": "FIqlRW_manualSizeToggle",
  "open": "FIqlRW_open",
  "root": "FIqlRW_root",
  "row": "FIqlRW_row",
  "selectWrapper": "FIqlRW_selectWrapper",
  "selected": "FIqlRW_selected",
  "sizes": "FIqlRW_sizes",
  "sizingKitButton": "FIqlRW_sizingKitButton",
  "sizingKitSection": "FIqlRW_sizingKitSection",
  "submit": "FIqlRW_submit",
  "subtitle": "FIqlRW_subtitle",
  "subtitleStyle": "FIqlRW_subtitleStyle",
  "tag": "FIqlRW_tag",
  "textDescription": "FIqlRW_textDescription",
  "title": "FIqlRW_title",
  "titles": "FIqlRW_titles",
  "toggleArrow": "FIqlRW_toggleArrow",
  "visible": "FIqlRW_visible",
});
